import { connect } from 'react-redux';
import App from '../components/app';
import { AppState } from '../types';

export const mapDispatchToProps = {};

export const mapStateToProps = (state: AppState) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App);
